export default "__VITE_ASSET__0acb698b__"